<script>
    import Layout from "../../layouts/main";
    import PageHeader from "../../components/page-header";
    import subCategoryList from "./sub-category-list";
    export default {
    components: { Layout, PageHeader, subCategoryList },
    data() {
        return {};
    }
    };

</script>

<template>
  <Layout>
    <sub-category-list/>
  </Layout>
</template>